import {
  SequenceMenu,
  usePersistMagicTableQueryParams
} from '@sequencehq/core-components'
import { useNavigate } from 'react-router-dom'
import { usageMetricsPaths } from 'modules/UsageMetrics/usageMetrics.router'
import { usePermissions } from 'lib/rbac'

export const ViewUsageMetric = (props: { usageMetricId: string }) => {
  const navigate = useNavigate()
  const { persistMagicTableQueryParams } = usePersistMagicTableQueryParams()

  const { can } = usePermissions()

  if (!can('org.usage:read')) {
    return null
  }

  return (
    <SequenceMenu.Item
      data-testid="usageMetrics.viewUsageMetric.menuItem"
      uuid="view-usage-metric"
      label="View usage metric"
      onClick={() => {
        navigate(
          persistMagicTableQueryParams(
            usageMetricsPaths.view(props.usageMetricId)
          )
        )
      }}
    />
  )
}
